import { FC } from "react";

interface ClientsProps {
  
}
 
const Clients: FC<ClientsProps> = () => {
  return (
    <div
      className="bloc d-bloc bloc-bg-texture texture-darken-strong none bloc-fill-screen"
      id="clients-section"
    >
      <div className="container">
        <div className="row">
          <div className="offset-lg-1 col-lg-10">
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h1 className="mg-md text-lg-center h1-about-style text-white">
                  Our Clients
                </h1>
              </div>
            </div>
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h2 className="mg-md text-lg-center h3-about-style text-white fix-header">
                  We make it happen together.
                </h2>
              </div>
            </div>
            <p className="text-lg-center p-7-style scroll-fx-up-in mt-md-4 mt-sm-2">
              We are proud to have worked with clients of renown and prestige.
              We believe that they are a testament to the quality of the service
              we offer. The outstanding relationship we enjoy with our clients
              motivates us to provide them with world-class service. To better
              understand the needs of each of our clients and provide them with
              the development solutions that best suit their requirements, we
              put all of our expertise and knowledge at their disposal. Our
              clients are drawn from a wide range of private and public
              companies and include multiple sectors: insurance, finance,
              telecommunications, media and health.
            </p>
          </div>
        </div>
        <div className="row">
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://www.synechron.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/synechron.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-11-style"
                alt="telus"
              />
            </a>
          </div>
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://systematix.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/systematix.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-11-style"
                alt="telus"
              />
            </a>
          </div>
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://americas.societegenerale.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/societe.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-style"
                alt="societe"
              />
            </a>
          </div>
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://www.bell.ca/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/bell.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-experiences-style"
                alt="bell"
              />
            </a>
          </div>
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://www.alphacco.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/alphacco.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-alphac-style"
                alt="alphacco"
              />
            </a>
          </div>
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://www.oiq.qc.ca/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/oiq2.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-8-style"
                alt="oiq2"
              />
            </a>
          </div>
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://ici.radio-canada.ca/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/ici.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-9-style"
                alt="ici"
              />
            </a>
          </div>
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://www.investpsp.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/psp.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-10-style"
                alt="psp"
              />
            </a>
          </div>
          <div
            className="col-lg-3 col-md-6 mt-1 mt-md-4 mt-lg-0 animated zoomIn"
            data-appear-anim-style="zoomIn"
          >
            <a
              href="https://www.telus.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="img/clients/telus.png"
                className="img-fluid mx-auto d-block animated pulse-hvr img-11-style"
                alt="telus"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
 
export default Clients;